(() => {
  const KEY = 'fog_recent_products';
  const rootPath = () => (window.Shopify?.routes?.root || '/');
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100); }
    catch (_) { return `$${(Number(cents || 0) / 100).toFixed(2)}`; }
  };
  function sizedImage(url, width) {
    if (!url) return '';
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  }
  function saveHandle(handle) {
    if (!handle) return [];
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
    handles = [handle, ...handles.filter((item) => item !== handle)].slice(0, 8);
    localStorage.setItem(KEY, JSON.stringify(handles));
    return handles;
  }
  async function getProduct(handle) {
    const response = await fetch(`${rootPath()}products/${handle}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Product unavailable');
    return response.json();
  }
  function card(product) {
    const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
    const image = product.featured_image || product.images?.[0] || '';
    const image360 = sizedImage(image, 360);
    const image540 = sizedImage(image, 540);
    const image720 = sizedImage(image, 720);
    return `<article class="fog-recent-card">
      <a href="${product.url}" class="fog-recent-card__image"><img src="${image540}" srcset="${image360} 360w, ${image540} 540w, ${image720} 720w" sizes="(min-width: 990px) 30vw, 90vw" alt="${product.title.replace(/"/g,'&quot;')}" loading="lazy" decoding="async" fetchpriority="low"></a>
      <div class="fog-recent-card__body"><a href="${product.url}" class="fog-recent-card__title">${product.title}</a><p>${variant ? money(variant.price) : ''}</p></div>
    </article>`;
  }
  async function init() {
    const section = document.querySelector('[data-fog-recently-viewed]');
    if (!section) return;
    const current = section.dataset.currentHandle;
    const all = saveHandle(current);
    const limit = Number(section.dataset.limit || 3);
    const handles = all.filter((handle) => handle !== current).slice(0, limit);
    if (!handles.length) return;
    const products = (await Promise.all(handles.map((handle) => getProduct(handle).catch(() => null)))).filter(Boolean);
    if (!products.length) return;
    section.querySelector('[data-fog-recent-grid]').innerHTML = products.map(card).join('');
    section.hidden = false;
  }
  document.addEventListener('DOMContentLoaded', init);
})();
